module.exports = __webpack_public_path__ + "img/img2.1731d453.png";